import React, { useState, useMemo } from 'react'
import ExportDrawer from 'components/shared/ExportDrawer'
import { exportActions } from 'businesslayer/api/actions'
import { saveFile } from 'common/util/file'
import { ToastNotification } from 'components/atlas-components/atlas-toast/ToastNotification'

export const useExportOptionsModal = () => {
    const [showModal, setShowModal] = useState(false)
    const [slectedMinuteItem, setSlectedMinuteItem] = useState<any>([])
    const [committeeId, setCommitteeId] = useState<string>('')
    const [toastMessage, setToastMessage] = useState('')
    const [showToast, setShowToast] = useState(false)
    const [toastType, setToastType] = useState('')

    const handleOpenExportOptionsModal = (minutesItem, committeeId) => {
        setSlectedMinuteItem(minutesItem)
        setCommitteeId(committeeId)
        setShowModal(true)
    }
    const handleCloseExportOptionsModal = () => {
        setShowModal(false)
    }
    const makeHandleExportActions = (minutesId, sortField) => async () => {
        try {
            const response = await exportActions(
                committeeId,
                minutesId,
                sortField,
                exportActions.bind(null, committeeId, minutesId, sortField)
            )
            handleDownloadFile({ response, responseType: 'xlsx' })
        } catch (error) {}
    }
    const handleDownloadFile = ({ response, responseType }) => {
        saveFile({ response, responseType })
    }
    const sortField = { name: 'section', ascending: true }

    const renderToastNotification = useMemo(
        () => (
            <ToastNotification
                message={toastMessage}
                showToast={showToast}
                setShowToast={setShowToast}
                toastType={toastType}
            />
        ),
        [toastMessage, showToast, setShowToast, toastType]
    )

    const ExportOptionsModal = !!showModal ? (
        <ExportDrawer
            key="exportOptionsModal"
            isOpen={!!showModal}
            setIsOpen={handleCloseExportOptionsModal}
            minutesItem={slectedMinuteItem}
            onExportActionsOnly={makeHandleExportActions(slectedMinuteItem?.id, sortField)}
            setToastMessage={setToastMessage}
            setShowToast={setShowToast}
            setToastType={setToastType}
        />
    ) : null

    const toastNotification = showToast ? renderToastNotification : null

    return { ExportOptionsModal, handleOpenExportOptionsModal, toastNotification }
}
